<template>
  <div class="dashed-hr py-10">
    <img src="@/assets/images/bg/dashed-hr.svg" alt="">
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>
